import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
export default function GroupChatHome() {
  const navigate = useNavigate();
  const [roomName, setRoomName] = useState<string>('');
  const normalized = roomName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-');
  const invalid = normalized.length > 80;
  return (
    <Card sx={{ maxWidth: 800, mx: 'auto' }}>
      <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
        <Stack
          spacing={3}
          component="form"
          onSubmit={(event) => {
            event.preventDefault();
            if (normalized && !invalid) navigate(`/group-chat/room/${normalized}`);
          }}
        >
          <Typography variant="h4" component="h1">
            Group Chats
          </Typography>
          <Typography>Join a named room shared by signed-in users.</Typography>
          <Button component={RouterLink} to="/group-chat/room/lobby" sx={{ alignSelf: 'flex-start' }}>
            Join the lobby
          </Button>
          <TextField
            label="Room ID"
            value={roomName}
            onChange={(event) => setRoomName(event.target.value)}
            error={invalid}
            helperText={
              invalid ? 'Use at most 80 characters.' : 'Letters and numbers are kept; other characters become hyphens.'
            }
          />
          <Button type="submit" variant="contained" disabled={!normalized || invalid}>
            Join Room
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
